<template>
  <div>
    <v-dialog
        v-model="dialog"
        max-width="500px"
    >
      <template v-slot:activator="{ on }">
        <v-btn
            dark
            large
            icon
            text
            v-on="on"
            title="Upload files"
        >
          <v-icon>mdi-cloud-upload</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-list-item dark class="primary lighten-1 py-2">
          <v-list-item-avatar>
            <v-icon>mdi-cloud-upload</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="headline">Documents Upload</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click.stop="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-card-text>
          <v-form class="pt-4">
            <v-tabs v-model="tab">
              <v-tab>Direct Upload</v-tab>
              <!--              <v-tab>From Link</v-tab>-->
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card
                    class="pa-4"
                    flat
                >
                  <v-file-input
                      v-model="files"
                      :show-size="1000"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      multiple
                      outlined
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                  >
                    <template v-slot:selection="{ index, text }">
                      <v-chip
                          v-if="index < 2"
                          color="deep-purple accent-4"
                          dark
                          label
                          small
                      >
                        {{ text }}
                      </v-chip>
                      <span
                          v-else-if="index === 2"
                          class="overline grey--text text--darken-3 mx-2"
                      >+{{ files.length - 2 }} File(s)</span>
                    </template>
                  </v-file-input>
                </v-card>
              </v-tab-item>
              <!--              <v-tab-item>-->
              <!--                <v-card flat>-->
              <!--                  <v-text-field-->
              <!--                      v-model="fileUrl"-->
              <!--                      label="File link"-->
              <!--                      prepend-icon="mdi-link"-->
              <!--                      hint="Google Drive shareable link"-->
              <!--                      outlined-->
              <!--                  />-->
              <!--                </v-card>-->
              <!--              </v-tab-item>-->
            </v-tabs-items>

            <v-divider class="mb-6"></v-divider>
            <v-autocomplete
                label="Folder"
                v-model="folder"
                :items="folders"
                item-text="name"
                item-value="id"
                prepend-icon="mdi-folder"
                clearable
                outlined
            ></v-autocomplete>
            <v-autocomplete
                label="Linked to"
                v-model="applicant"
                :items="applicants"
                item-text="fullname"
                item-value="id"
                prepend-icon="mdi-account"
                clearable
                outlined
            ></v-autocomplete>
          </v-form>
        </v-card-text>
        <v-card-actions class="text-right">
          <div class="flex-grow-1"></div>
          <v-progress-circular
              v-if="uploading"
              indeterminate
              color="purple"
          ></v-progress-circular>
          <v-btn
              @click.stop="upload()"
              :disabled="uploading"
              text
              large
              color="secondary"
          >Upload
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {errorNotification} from "@/components/utils";

export default {
  components: {},
  name: 'DocumentsUploadDialog',
  props: {
    id: Number,
  },
  data() {
    return {
      dialog: false,
      applicants: [],
      folders: [],
      files: [],
      applicant: null,
      folder: null,
      uploading: false,
      tab: null,
      fileUrl: null
    }
  },
  methods: {
    fetchOptions() {
      // Fetch possible options
      this.$axios.get('/applications/' + this.id + '/folders/')
          .then((response) => {
            this.folders = response.data
            // Prepend parent folder name to level 2 sub folders
            this.folders.forEach((folder) => {
              if (folder.parent) {
                let parentIndex = this.folders.findIndex(f => f.id === folder.parent)
                folder.name = this.folders[parentIndex]['name'] + ' / ' + folder.name
              }
            })
          })
          .catch((error) => {
            errorNotification(error)
          })
      this.$axios.get('/applications/' + this.id + '/applicants/', {})
          .then((response) => {
            this.applicants = response.data
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    upload() {
      this.files.forEach((file) => {
        let data = new FormData()
        data.append('application', this.id)
        if (this.applicant) {
          data.append('applicant', this.applicant)
        }
        if (this.folder) {
          data.append('folder', this.folder)
        }
        data.append('name', file.name)
        data.append('file', file)
        this.uploading = true
        this.$axios.post('/application/documents/', data)
            .then(() => {
              let index = this.files.indexOf(file)
              this.files.splice(index, 1)
              this.$store.dispatch('snackbar/success', file.name + ' uploaded')
              this.$emit('success')
            })
            .catch((error) => {
              errorNotification(error)
            })
            .finally(() => {
              this.uploading = false
            })
      })
    }
  },
  mounted() {
    this.fetchOptions()
  }
}
</script>